import { ListConfirmationComponent } from './list-confirmation/list-confirmation.component';
import { SharedService } from './shared.service';
import { MalihuScrollbarModule } from 'ngx-malihu-scrollbar';
import { RouterModule } from '@angular/router';
import { SnackBarComponent } from './snack-bar/snack-bar.component';
import { VirtualKeyboardComponent } from './virtual-keyboard/virtual-keyboard.component';
import { MainMenuComponent } from './main-menu/main-menu.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { ProfileComponent } from './profile/profile.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { McBreadcrumbsModule } from 'ngx-breadcrumbs';
import { MainTitleComponent } from './main-title/main-title.component';
import { MatRadioModule, MatListModule, MatProgressSpinnerModule, MatButtonModule, MatAutocompleteModule, MatInputModule, MatSelectModule, MatCardModule, MatDatepickerModule, MatIconModule } from '@angular/material';
import { CurrentBalanceComponent } from './current-balance/current-balance.component';
import { FormatPricePipe } from './format-price.pipe';
import { BlockPreloaderComponent } from './block-preloader/block-preloader.component';
import { PreloaderComponent } from './preloader/preloader.component';
import { ExportButtonsComponent } from './export-buttons/export-buttons.component';
import { WarningComponent } from './warning/warning.component';
import { VirtualNumPadComponent } from './virtual-num-pad/virtual-num-pad.component';
import { StepButtonsComponent } from './step-buttons/step-buttons.component';
import { SignatureComponent } from './signature/signature.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CpfCnpjPipe } from './cpf-cnpj.pipe';
import { AccountNumberPipe } from './account-number.pipe';
import { TermsComponent } from './terms/terms.component';
import { ModalErrorComponent } from './modal-error/modal-error.component';
import { ModalNoticeComponent } from './modal-notice/modal-notice.component';
import { CustumerServiceClientInfoComponent } from './custumer-service-client-info/custumer-service-client-info.component';
import { ModalAnswerComponent } from './custumer-service-client-info/modal-answer/modal-answer.component';
import { AgencyPipe } from './agency.pipe';
import { MatDialogModule } from '@angular/material/dialog';
import { CreditCardService } from './cards/credit-card.service';
import { ModalTermsComponent } from './modal-terms/modal-terms.component';
import { CepPipe } from './cep.pipe';
import { ModalConfirmComponent } from './modal-confirm/modal-confirm.component';
import { AppOnlyFeatureService } from './app-only-feature/app-only-feature.service';
import { AppOnlyFeatureGuard } from './guards/app-only-feature.guard';
import { SharedValidationCodeComponent } from './sms-validation-signature/shared-validation-code.component';
import { SimpleExportButtonsComponent } from './simple-export-buttons/simple-export-buttons.component';
import { NgxMaskModule } from 'ngx-mask';
import { CurrencyMaskModule } from 'ngx-currency-mask';
import { PhonePipe } from './phone.pipe';
import { SharedModalInfoComponent } from './modal-info/modal-info.component';
import { SharedModalInfoListComponent } from './modal-info-list/modal-info-list.component';
import { SignatureWithStepsComponent } from './signature-with-steps/signature-with-steps.component';
import { FormatPriceSignalPipe } from './format-price-signal.pipe';
import { SharedFilterPeriodComponent } from './filter-period/filter-period.component';
import { PixAccessService } from './pix-access/pix-access.service';
import { PrintLogoComponent } from './print/logo/print-logo.component';
import { PrintFooterComponent } from './print/footer/print-footer.component';
import { InconsistenciaComponent } from './modal-inconsistencia/inconsistencia.component';
import { CpfCnpjPixPipe } from './cpf-cnpj-pix.pipe';
import { ModalSucessComponent } from './modal-sucess/modal-sucess.component';
import { CurrentTimeService } from './services/current-time.service';
import { SharedAccordionComponent } from './accordion/accordion.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { AntifraudWarningComponent } from './antifraud-warning/antifraud-warning.component';
import { ModalAntifraudWarningComponent } from './modal-antifraud-warning/modal-antifraud-warning.component';
import { ModalConfirmService } from './modal-confirm/modal-confirm.service';

@NgModule({
	imports: [
		CommonModule,
		MatSnackBarModule,
		RouterModule,
		McBreadcrumbsModule.forRoot(),
		MalihuScrollbarModule.forRoot(),
		MatRadioModule,
		MatListModule,
		MatProgressSpinnerModule,
		FormsModule,
		ReactiveFormsModule,
		MatButtonModule,
		MatIconModule,
		MatAutocompleteModule,
		MatInputModule,
		MatSelectModule,
		MatDialogModule,
		NgxMaskModule.forRoot(),
		CurrencyMaskModule,
		MatCardModule,
		MatDatepickerModule,
		MatExpansionModule
	],
	declarations: [
		MainMenuComponent,
		VirtualKeyboardComponent,
		HeaderComponent,
		NotificationsComponent,
		ProfileComponent,
		BreadcrumbComponent,
		SnackBarComponent,
		MainTitleComponent,
		CurrentBalanceComponent,
		AgencyPipe,
		FormatPricePipe,
		FormatPriceSignalPipe,
		CpfCnpjPipe,
		CpfCnpjPixPipe,
		AccountNumberPipe,
		CepPipe,
		PhonePipe,
		BlockPreloaderComponent,
		PreloaderComponent,
		ExportButtonsComponent,
		SimpleExportButtonsComponent,
		WarningComponent,
		VirtualNumPadComponent,
		StepButtonsComponent,
		SignatureComponent,
		ListConfirmationComponent,
		TermsComponent,
		ModalErrorComponent,
		ModalNoticeComponent,
		CustumerServiceClientInfoComponent,
		ModalAnswerComponent,
		ModalTermsComponent,
		ModalConfirmComponent,
		SharedModalInfoComponent,
		SharedValidationCodeComponent,
		SharedModalInfoListComponent,
		SignatureWithStepsComponent,
		SharedFilterPeriodComponent,
		PrintLogoComponent,
		PrintFooterComponent,
		InconsistenciaComponent,
		ModalSucessComponent,
		SharedAccordionComponent,
		AntifraudWarningComponent,
		ModalAntifraudWarningComponent,
	],
	exports: [
		MainMenuComponent,
		VirtualKeyboardComponent,
		HeaderComponent,
		NotificationsComponent,
		ProfileComponent,
		BreadcrumbComponent,
		SnackBarComponent,
		MainTitleComponent,
		McBreadcrumbsModule,
		CurrentBalanceComponent,
		AgencyPipe,
		FormatPricePipe,
		FormatPriceSignalPipe,
		CpfCnpjPipe,
		CpfCnpjPixPipe,
		AccountNumberPipe,
		CepPipe,
		PhonePipe,
		BlockPreloaderComponent,
		PreloaderComponent,
		ExportButtonsComponent,
		SimpleExportButtonsComponent,
		WarningComponent,
		VirtualNumPadComponent,
		StepButtonsComponent,
		SignatureComponent,
		ListConfirmationComponent,
		TermsComponent,
		ModalErrorComponent,
		ModalNoticeComponent,
		CustumerServiceClientInfoComponent,
		ModalAnswerComponent,
		ModalTermsComponent,
		ModalConfirmComponent,
		SharedModalInfoComponent,
		SharedValidationCodeComponent,
		SharedModalInfoListComponent,
		SignatureWithStepsComponent,
		SharedFilterPeriodComponent,
		PrintLogoComponent,
		PrintFooterComponent,
		SharedAccordionComponent,
		AntifraudWarningComponent,
		ModalAntifraudWarningComponent,
	],
	providers: [
		SharedService,
		CreditCardService,
		PixAccessService,
		CurrentTimeService,
		ModalConfirmService,
		AppOnlyFeatureService,
		AppOnlyFeatureGuard,
	],
	entryComponents: [
		ModalTermsComponent,
		ModalConfirmComponent,
		SharedModalInfoComponent,
		SharedModalInfoListComponent,
		InconsistenciaComponent,
		ModalAntifraudWarningComponent
	],
})
export class SharedModule { }



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/shared/shared.module.ts